export default "__VITE_ASSET__b53fb85f__"